exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "agm-map {\r\n    height: 400px;\r\n  }\r\n\r\n.contactuscontainer{\r\n  max-width: 540px;\r\n  margin: auto;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Angular/website-angular/src/app/components/contactus/contactus.component.css
// module id = ../../../../../src/app/components/contactus/contactus.component.css
// module chunks = main